module.exports = __webpack_public_path__ + "static/media/dex.aa965982.png";